// extracted by mini-css-extract-plugin
module.exports = {"articleIndex":"InThisArticle_articleIndex__nfLrw"};